<div *ngIf="!showRequest">
  <h2 *ngIf="isShow" class="sectionTitle">{{'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.FORM_TITLE' | translate }}</h2>

  <div *ngIf="baseRequestId && showTransitRequest" class="read-only-content">
    <!-- request Details summary -->
    <app-transit-request #TransitRequest (latestStepId)="receiveLatestStepId($event)"
      [IsAdminMode]="true"></app-transit-request>
  </div>
  <div *ngIf="showTransitIssueResolution" class="read-only-content">
    <!-- request Details summary -->
    <app-transit-issue-resolution #TransitIssueResolution (latestStepId)="receiveLatestStepId($event)"
      [isShow]="false"></app-transit-issue-resolution>
  </div>
  <div *ngIf="showLimitTimeAcceptance" class="read-only-content">
    <!-- request Details summary -->
    <app-agent-approval-limit-time-rate #LimitTimeAcceptance (latestStepId)="receiveLatestStepId($event)"
      [isShow]="false"></app-agent-approval-limit-time-rate>
  </div>


  <div *ngIf="showNavigationNotes" class="bs-callout bs-callout-info">
    <h4>{{'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.NAVIGATION_NOTES' | translate}}</h4>
    <p>{{ navigationNotes }}</p>
  </div>

  <div *ngIf="baseRequestId">
    <form [formGroup]="confirmVesselEntranceForm">
      <div class="form-container">
        <div class="form-section">
          <h4 class="section-title">{{'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.CONFIRM_ENTRANCE_DECISION' |
            translate}}</h4>
          <div class="form-group">
            <label>{{'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.DECISION_LABEL' | translate}} <span
                class="red">*</span></label>
            <div class="form-custom-inputs">
              <div *ngFor="let opt of decisionKeys" class="custom-Radio">
                <input type="radio" [id]="opt" [value]="decision[opt]" formControlName="Decision" name="Decision"
                  (change)="changeDecision(decision[opt])" />
                <label [for]="opt">{{ 'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.' + opt | translate }}</label>
              </div>
            </div>
            <div *ngIf="submitted || (f.Decision?.dirty && f.Decision?.errors)" class="red">
              <div *ngIf="f.Decision?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="decisionValue === decision.CONFIRM_TRANSIT">
            <label for="convoyDate">{{'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.CONVOY_DATE' | translate}} <span
                class="red">*</span></label>
            <input class="form-control" #convoyDatepicker="bsDatepicker" bsDatepicker formControlName="ConvoyDate"
              id="convoyDate" [bsConfig]="{dateInputFormat: 'YYYY-MM-DD'}" autocomplete="off" />
            <div *ngIf="submitted || (f.ConvoyDate?.dirty && f.ConvoyDate?.errors)" class="red">
              <div *ngIf="f.ConvoyDate?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group" *ngIf="decisionValue === decision.CANCEL_TRANSIT">
            <label for="reason">{{'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.NOTES' | translate}} <span
                class="red">*</span></label>
            <textarea id="reason" formControlName="Reason" class="form-control"></textarea>
            <div *ngIf="submitted || (f.Reason?.dirty && f.Reason?.errors)" class="red">
              <div *ngIf="f.Reason?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group" *ngIf="decisionValue === decision.SEND_TO_NAVIGATION">
            <label for="notes">{{'ADMIN_USER.TRANSIT.CONFIRM_VESSEL_ENTRANCE.NOTES' | translate}} <span
                class="red">*</span></label>
            <textarea id="notes" formControlName="Notes" class="form-control"></textarea>
            <div *ngIf="submitted || (f.Notes?.dirty && f.Notes?.errors)" class="red">
              <div *ngIf="f.Notes?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="(alert && formMode === FormMode.Add)" class="alert alert-warning" role="alert">
        {{ 'FRONT_USER.TRANSIT_REQUEST_FORM.IS_ESTIMATEDFEES_NOT_PAID' | translate }}
      </div>
      <div *ngIf="(formMode == FormMode.Add && !alert )" class="form-group">
        <button Confirmation (confirmationClick)="onSubmit()" class="btn btn-primary SCAcustomBtn">{{
          'FRONT_USER.CONFIRM' | translate}}</button>
      </div>
    </form>
  </div>
</div>

<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingTasks">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_TASKS' | translate }}</a></p>
  </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingTasks">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_TASKS' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/ebookingTasks">
        {{ 'FRONT_USER.WORKSPACE.EBOOKING_TASKS' | translate }}</a></p>
  </div>
</div>